export default {
  placeholder: 'Write your note...',
  insert: 'Insert Text',
  label: {
    link: 'Link',
  },
  button: {
    confirm: 'Confirm',
  },
};
